var _circle, _path, _path2, _circle2, _circle3, _circle4, _circle5, _path3, _path4, _path5, _circle6, _circle7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStep1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "url(#paint0_radial_18_381)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37 26.8442C37 25.8257 37.8257 25 38.8442 25H54.1558C55.1743 25 56 25.8257 56 26.8442V28.1558C56 29.1743 55.1743 30 54.1558 30H38.8442C37.8257 30 37 29.1743 37 28.1558V26.8442Z",
    fill: "white",
    stroke: "#1A1A1A",
    strokeWidth: 0.922103
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.999 38.8442C58.999 37.8257 59.8247 37 60.8432 37H75.1548C76.1733 37 76.999 37.8257 76.999 38.8442V40.1558C76.999 41.1743 76.1733 42 75.1548 42H60.8432C59.8247 42 58.999 41.1743 58.999 40.1558V38.8442Z",
    fill: "white",
    stroke: "#1A1A1A",
    strokeWidth: 0.922103
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 44.168,
    cy: 36.1684,
    r: 1.37395,
    stroke: "#FF7206",
    strokeWidth: 0.922103
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 49.333,
    cy: 47,
    r: 1.53895,
    stroke: "#FF7206",
    strokeWidth: 0.922103
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.999,
    cy: 63,
    r: 1.53895,
    stroke: "#FF7206",
    strokeWidth: 0.922103
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 67,
    r: 2.53895,
    stroke: "#FF7206",
    strokeWidth: 0.922103
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8611 53.1438L51.9345 52.6886L51.8611 53.1438ZM61.5925 61.2175C61.7126 61.442 61.992 61.5266 62.2165 61.4065C62.441 61.2864 62.5257 61.0071 62.4056 60.7825L61.5925 61.2175ZM33.5666 54.3511C33.7776 54.9218 34.445 55.647 35.4302 56.2213C36.4379 56.8086 37.8301 57.2711 39.566 57.2711V56.349C37.9972 56.349 36.7648 55.9318 35.8946 55.4246C35.002 54.9044 34.5382 54.3202 34.4315 54.0314L33.5666 54.3511ZM39.566 57.2711C41.7926 57.2711 43.4396 55.9949 45.1393 54.9941C46.8624 53.9793 48.7921 53.1159 51.7877 53.599L51.9345 52.6886C48.6439 52.158 46.4914 53.1277 44.6714 54.1995C42.8278 55.2851 41.4704 56.349 39.566 56.349V57.2711ZM51.7877 53.599C54.8943 54.0999 57.3423 55.9843 59.03 57.7804C59.8708 58.6752 60.5141 59.5388 60.9466 60.1781C61.1627 60.4975 61.3256 60.7601 61.4339 60.9416C61.488 61.0323 61.5284 61.1027 61.5549 61.1497C61.5682 61.1732 61.5779 61.1909 61.5842 61.2023C61.5873 61.208 61.5896 61.2122 61.591 61.2147C61.5917 61.216 61.5921 61.2168 61.5924 61.2173C61.5925 61.2175 61.5926 61.2177 61.5926 61.2177C61.5926 61.2177 61.5926 61.2176 61.5926 61.2177C61.5925 61.2176 61.5925 61.2175 61.999 61C62.4056 60.7825 62.4055 60.7824 62.4054 60.7822C62.4053 60.7821 62.4052 60.7819 62.4051 60.7817C62.4049 60.7813 62.4046 60.7808 62.4043 60.7802C62.4037 60.779 62.4028 60.7774 62.4017 60.7754C62.3996 60.7714 62.3965 60.7658 62.3925 60.7586C62.3846 60.7442 62.3732 60.7235 62.3581 60.6968C62.3281 60.6436 62.284 60.5667 62.2258 60.4692C62.1095 60.2743 61.9372 59.9967 61.7103 59.6614C61.257 58.9913 60.5837 58.0873 59.702 57.149C57.9447 55.2788 55.3238 53.2351 51.9345 52.6886L51.7877 53.599Z",
    fill: "#1A1A1A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.333 30V44.8564C53.333 45.1692 53.4126 45.4769 53.5643 45.7505L63.502 63.6775C66.5683 69.2088 62.5682 76 56.2438 76H35.827C29.412 76 25.4226 69.0326 28.6699 63.5002L39.0793 45.7656C39.2454 45.4826 39.333 45.1603 39.333 44.8321V30",
    stroke: "#1A1A1A",
    strokeWidth: 0.922103
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M75 60V42H61V60C61 63.866 64.134 67 68 67C71.866 67 75 63.866 75 60Z",
    fill: "white",
    stroke: "#1A1A1A",
    strokeWidth: 0.922103
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 65.334,
    cy: 48.6666,
    r: 1.53895,
    fill: "white",
    stroke: "#FF7206",
    strokeWidth: 0.922103
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 69.1672,
    cy: 60.1666,
    r: 2.03895,
    fill: "white",
    stroke: "#FF7206",
    strokeWidth: 0.922103
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_18_381",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.2591 49.7409) rotate(-64.006) scale(69.7502)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.282198,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.862101,
    stopColor: "#EFFBFF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep1);
export default __webpack_public_path__ + "static/media/step1.af4ce1909eca26d8940ce5943fbbbd53.svg";
export { ForwardRef as ReactComponent };